



















import { Component, Ref, Vue, Watch } from 'vue-property-decorator'

@Component
export default class Templates extends Vue {}
